import useFetchApi from "@/api/hooks/useFetchApi";
import BreadCrumb from "@/components/BreadCrumb";
import BlogCard from "@/components/Cards/BlogCard";
import Loader from "@/components/Loader/loader";
import React from "react";

const BlogPage: React.FC = () => {

    const {
        data,
        isLoading,
        error
    } = useFetchApi({
        url: "/v1/main-module/677fadabd2c0311ca14f6b76/collection/find",
        service: "CMS_PROC"
    })

    return (
        <>
            <BreadCrumb title="Blog" parent="Blog" child="" />
            {(isLoading === false && data) ? (
                <>
                    <section className="ls page_portfolio section_padding_top_100 section_padding_bottom_75">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="isotope_container isotope row masonry-layout columns_margin_bottom_30" >
                                        {data?.results.map((item: any, index: number) => {
                                            return (
                                                <>
                                                    <BlogCard key={index} data={item} isLoading={isLoading} />
                                                </>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            ) : <><Loader /></>
            }
            <br />
            <br />
        </>
    )
}

export default BlogPage;